import { Badge } from "@/components/ui/badge";
import { PhysicalClientStatus } from "@/lib/api";
import { STATUS_BADGE_VARIANTS, STATUS_LABELS } from "./physicalClientLabels";

export function PhysicalClientStatusBadge({ status }: { status: PhysicalClientStatus }) {
  return <Badge variant={STATUS_BADGE_VARIANTS[status]}>{STATUS_LABELS[status]}</Badge>;
}
